import { render, staticRenderFns } from "./SignalTest.vue?vue&type=template&id=37b396a9"
import script from "./SignalTest.vue?vue&type=script&lang=js"
export * from "./SignalTest.vue?vue&type=script&lang=js"
import style0 from "./SignalTest.vue?vue&type=style&index=0&id=37b396a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports